import React from 'react';
import CertificationTiers from './certificationTiersHero';
import CertificationBanner from './certificationBanner';
import TechnologyCertifications from '../TechnologyCertifications';
import FunctionalCertifications from './functionalCertifications';

export default function ProfessionalServicesProviders() {
  return (
    <div className="grid grid-cols-1 font-sans">
      <CertificationTiers></CertificationTiers>
      <CertificationBanner></CertificationBanner>
      <TechnologyCertifications></TechnologyCertifications>
      <FunctionalCertifications></FunctionalCertifications>
    </div>
  );
}
